import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=53e2a486&scoped=true&functional=true&"
import script from "./EventCard.vue?vue&type=script&lang=js&"
export * from "./EventCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "53e2a486",
  null
  
)

export default component.exports